<template>
    <DButton
        id="trainings-course"
        v-c-tooltip="__('messages.header.trainings_course.title')"
        icon="school"
        :href="trainingsCourseLink"
        target="_blank"
    />
</template>

<script setup>
defineProps({
    trainingsCourseLink: {
        type: String,
        default: () => { return null }
    }
})
</script>
